import { render, staticRenderFns } from "./Searches.vue?vue&type=template&id=2164cab0&scoped=true&"
import script from "./Searches.vue?vue&type=script&lang=js&"
export * from "./Searches.vue?vue&type=script&lang=js&"
import style0 from "./Searches.vue?vue&type=style&index=0&id=2164cab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164cab0",
  null
  
)

export default component.exports